import ThemedForm from '~/components/forms/ThemedForm.jsx';
import FormBackgroundContainer from '~/components/forms/FormBackgroundContainer.jsx';
import PageContainer from '~/public/components/PageContainer.jsx';
import ErrorMessageBlock from '~/components/ErrorMessageBlock.jsx';
import React, { useState } from 'react';
import FormPaymentForm from '~/public/components/PaymentForm.jsx';
import { ErrorContext } from '~/lib/ErrorContext';

export function saveLastPaymentParams(paymentSettings, submission, lineItems) {
    sessionStorage.setItem(
        `last-payment-params`,
        JSON.stringify({
            paymentSettings,
            submission,
            lineItems,
        }),
    );
}

function getLastPaymentParams() {
    return JSON.parse(sessionStorage.getItem(`last-payment-params`));
}

export function hasSavedPaymentParams() {
    return !!getLastPaymentParams();
}

export function clearSavedPaymentParams() {
    sessionStorage.removeItem(`last-payment-params`);
}

/**
 * This is used when a payment fails and we need to show the payment form again
 *
 * @param error
 * @returns {Element}
 * @constructor
 */
export const FormPaymentFormWithSavedParams = ({ error }) => {
    const [errors, setErrors] = useState({});
    const { paymentSettings, submission, lineItems } = getLastPaymentParams();

    return (
        <ErrorContext.Provider value={{ errors, setErrors }}>
            <ThemedForm styles={submission?.form?.settings?.styles}>
                <FormBackgroundContainer
                    styles={submission?.form?.settings?.styles}
                >
                    <PageContainer>
                        {!!error && (
                            <ErrorMessageBlock>{error}</ErrorMessageBlock>
                        )}
                        <FormPaymentForm
                            paymentSettings={paymentSettings}
                            submission={submission}
                            lineItems={lineItems}
                        />
                    </PageContainer>
                </FormBackgroundContainer>
            </ThemedForm>
        </ErrorContext.Provider>
    );
};
